import {
  bindCurrencyFieldset,
  bindNavLinks,
  getEcwidUrl,
  getInputValue,
  initApp,
  localize,
  mergeTranslations,
  setInputValue,
  validateInput
} from "./utils";
import "./styles.css";
import { getAppSettings, setAppSettings } from "./app-settings";
import * as allSetupTrans from "./setup-translations";
import * as allSettingsTrans from './settings-translations';
import * as allAppSettingsTrans from './app-settings-translations';

initApp();

function submitForm(profile, settings) {
  return new Promise((resolve) => {
    const { account, generalInfo } = profile;
    const payload = {
      storeId: generalInfo.storeId,
      accountName: account.accountName,
      customerNumber: settings.customerNumber,
      accountEmail: account.accountEmail,
      storeUrl: generalInfo.storeUrl,
      storeName: profile.settings.storeName,
    };
    const url = settings.id ? `/account?id=${settings.id}` : "/account";
    $.ajax(url, {
      data: JSON.stringify(payload),
      contentType: "application/json",
      type: "POST",
    }).then(resolve);
  }).then((response) => {
    if (!response || !response.success) {
      return Promise.resolve(false);
    }
    return setAppSettings({
      id: response.id,
    }).then(() => Promise.resolve(true));
  });
}

$(function () {
  const storeData = EcwidApp.getPayload();

  bindNavLinks();

  const language = storeData.lang;
  const allTrans = mergeTranslations(allSettingsTrans, allSetupTrans, allAppSettingsTrans);
  const trans = allTrans[language] || allTrans["en"];
  localize(trans);

  getAppSettings(trans).then((settings) => {
    let profile;
    let accountEmail;
    $.get(getEcwidUrl("/profile", storeData), (response) => {
      profile = response;
      const { account, formatsAndUnits } = profile;
      accountEmail = account.accountEmail;
      $("#email").text(accountEmail);

      const { currencyPrefix, currencySuffix } = formatsAndUnits;
      bindCurrencyFieldset({ currencyPrefix, currencySuffix });
    });

    $("#step1").show();
    const $homePrice = $("#home-price");
    const $collectPrice = $("#collect-price");
    const $customerNumber = $("#customer-number");

    setInputValue($homePrice, settings.myPackHome.rate);
    setInputValue($collectPrice, settings.myPackCollect.rate);
    setInputValue($customerNumber, settings.customerNumber);

    $("#submit-setup").click(function () {
      submitForm(profile, settings).then(function(){
        $("#step3").fadeOut("slow", function () {
          $("#step4").fadeIn("slow");
        });
      })
    });

    $("#step1Next").click(function () {
      if (!validateInput($customerNumber)) {
        return;
      }
      setAppSettings({
        customerNumber: getInputValue($customerNumber),
      }, trans).then((newSettings) => {
        settings = newSettings;
        $("#step1").fadeOut("slow", function () {
          $("#step2").fadeIn("slow");
          $("#step2Next").click(function () {
            if (!validateInput($homePrice) || !validateInput($collectPrice)) {
              return;
            }
            setAppSettings({
              myPackHome: {
                rate: getInputValue($homePrice),
              },
              myPackCollect: {
                rate: getInputValue($collectPrice),
              },
            }, trans).then(() => {
              $("#step2").fadeOut("slow", function () {
                $("#step3").fadeIn("slow");
              });
            });
          });
        });
      });
    });
  });
});
